import { PageValidationFunctions } from '../types';
import { requestToVaryDetails, requestToVaryDetailsSoft } from './requestToVaryDetails';
import { requestToVaryDeclaration } from './requestToVaryDeclaration';

export const RequestToVary: PageValidationFunctions = {
    requestToVaryDetailsSoft,
    requestToVaryDetails,
    requestToVaryDeclaration,
};
